<template>
  <div v-if="checkVisibility">
    <add-heading :title="this.$t('profile.socialProfiles')" v-on:add="addClicked" :label="addLabel" :stepped="false" />
    <profile-section-readonly v-if="filteredProfiles.length > 0" :profiles="filteredProfiles"></profile-section-readonly>
    <div class="cards" v-else>
      <div class="card card-hover">
        <div class="card-content">
          <div class="empty-state is-flex" >
            <div class="is-circle m-b-16">
              <empty-state-icon></empty-state-icon>
            </div>
            <strong>{{this.$t('profile.socialProfiles')}}</strong>
            <div class="m-t-8" v-if="!isViewer">
              <a @click.prevent="addClicked" href=""> {{this.$t('profile.addSocialProfiles')}}</a> {{this.$t('profile.toYourProfile')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddHeading from '@/components/general/add-heading'
import { mapGetters } from 'vuex'
import EmptyStateIcon from '@/components/general/empty-state-icon'
import ProfileSectionReadonly from './profile-section-ro'

export default {
  components: { AddHeading, EmptyStateIcon, ProfileSectionReadonly },
  props: {
    isViewer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('users', ['profiles', 'socialProfiles', 'profilePictureUrl']),
    filteredProfiles () {
      if (!this.profiles) return []
      return this.profiles.filter((p) => {
        return p.profileValue !== null && p.profileValue !== ''
      })
    },
    addLabel () {
      if (this.isViewer) return 'More'
      return this.filteredProfiles.length > 0 ? this.$t('profile.edit') : this.$t('profile.add')
    },
    checkVisibility () {
      if (!this.isViewer) return true
      return this.filteredProfiles.length > 0
    }
  },
  methods: {
    addClicked () {
      this.$emit('add')
    }
  }
}
</script>

<style scoped>
  .empty-box {
    width: 48px;
    height: 48px;
    background-color: #f9f9f9;
    border-radius: 100%;
  }
  .empty-state {
    flex-direction: column;
    align-items: center;
  }
  .is-flex {
    flex-direction: column;
  }
  strong.label {
    letter-spacing: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/profiles/profile-section.vue